import React from 'react'
import { useElectron } from '@/hooks/useElectron'

const ElectronTitlebar: React.FC = () => {
  const { isElectron, platform } = useElectron()

  if (!isElectron) {
    return null
  }

  return (
    <div className={`electron-titlebar ${platform}`}>
      {/* Invisible draggable area - no content needed */}
    </div>
  )
}

export default ElectronTitlebar
